import React, { Component } from 'react';
import { connect } from 'react-redux';
import classes from './SignUpButtons.css';
import Button from '../../../components/UI/Button/Button';


class SignUpButtons extends Component {
    render () {        
        return (
            <div className={classes.SignUpButtons}>
                
                <Button 
                    btnType="Success"
                    clicked={this.props.submitted}>SUBMIT</Button>

                <Button 
                    btnType="Danger"
                    clicked={this.props.cancelled}>CANCEL</Button>
            </div>
        );
    }
};

export default SignUpButtons;


// WEBPACK FOOTER //
// ./src/components/Security/SignUpButtons/SignUpButtons.js